import * as React from "react";
const SvgFiRrCircleHalf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-half_svg__a)">
      <path
        fill="#062147"
        d="M9.99 24c-.22 0-.44-.02-.65-.07C3.93 22.75 0 17.74 0 12S3.93 1.25 9.33.07c.9-.2 1.83.02 2.55.6C12.59 1.24 13 2.09 13 3v18c0 .91-.41 1.76-1.12 2.33-.54.44-1.21.67-1.9.67zm0-22c-.07 0-.15 0-.22.02C5.34 2.99 2 7.28 2 12s3.34 9.01 7.76 9.98c.31.07.62 0 .87-.2.14-.11.37-.36.37-.77V3c0-.41-.23-.66-.37-.77-.18-.15-.41-.23-.64-.23"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-half_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleHalf;
